var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExternalLinkCustomFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Layer_2",
    width: 20,
    height: 20,
    "data-name": "Layer 2",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__external-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_7211",
    d: "M17.167 9.667a.833.833 0 0 0-.833.833v5a.833.833 0 0 1-.833.833H5.5a.833.833 0 0 1-.833-.833v-10a.833.833 0 0 1 .833-.833h5A.833.833 0 0 0 10.5 3h-5A2.5 2.5 0 0 0 3 5.5v10A2.5 2.5 0 0 0 5.5 18h10a2.5 2.5 0 0 0 2.5-2.5v-5a.833.833 0 0 0-.833-.833z",
    fill: "current",
    "data-name": "Path 7211",
    transform: "translate(-.5 -.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_7212",
    d: "M15.166 4.667h1.317L11.241 9.9a.837.837 0 1 0 1.183 1.183l5.242-5.233v1.317a.833.833 0 0 0 1.667 0V3.833A.833.833 0 0 0 18.5 3h-3.334a.833.833 0 0 0 0 1.667z",
    fill: "current",
    "data-name": "Path 7212",
    transform: "translate(-1.832 -.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExternalLinkCustomFill);
export default __webpack_public_path__ + "static/media/icon-external-link-custom-fill.852fec24c421537373a1f1004c143e14.svg";
export { ForwardRef as ReactComponent };